import React,{useEffect,useState} from "react";
import { Download, Save,Loader,Sun, Moon,X  } from "lucide-react";

export default function HeaderBar({ onExport, onSave,isRendering }) {

  const [isDark, setIsDark] = useState(
  () => localStorage.theme === "dark"
);

useEffect(() => {
  const root = document.documentElement;
  if (isDark) {
    root.classList.add("dark");
    localStorage.theme = "dark";
  } else {
    root.classList.remove("dark");
    localStorage.theme = "light";
  }
}, [isDark]);

  const handleClose = () => {
    window.parent.postMessage({ type: "closeEditor" }, "*");
  };

  return (
    <header className="
    w-full px-4 py-2 flex items-center justify-between
    bg-gray-100 dark:bg-gray-900
    border-b border-gray-200 dark:border-gray-800
    transition-colors
  ">
      
      {/* Left — Title */}
      <div className="flex items-center gap-2 text-lg font-semibold">
        🎬
        <span className="text-sm font-medium opacity-80">Reel Editor</span>
      </div>

      {/* Right — Icon Buttons */}
      <div className="flex items-center gap-3">

        {/* Export */}
        <button
          onClick={!isRendering ? onExport : undefined}  // disable clicking while loading
          className="
            p-2 rounded-md transition
            bg-gray-200 hover:bg-gray-300
            dark:bg-gray-800 dark:hover:bg-gray-700
            disabled:opacity-50
          "
          title="Export Video"
          disabled={isRendering}
        >
          {isRendering ? (
            <Loader size={18} className="animate-spin text-blue-400" />
          ) : (
            <Download size={18} />
          )}
        </button>

        {/* Save */}
        <button
          onClick={onSave}
          className="
            p-2 rounded-md transition
            bg-gray-200 hover:bg-gray-300
            dark:bg-gray-800 dark:hover:bg-gray-700
            disabled:opacity-50
          "
          title="Save"
        >
          <Save size={18} />
        </button>

        <button
          onClick={() => setIsDark((v) => !v)}
          title="Toggle theme"
          className="
            p-2 rounded-md
            bg-gray-200 hover:bg-gray-300
            dark:bg-gray-800 dark:hover:bg-gray-700
            transition-colors
          "
        >
          {isDark ? <Sun size={18} /> : <Moon size={18} />}
        </button>
        {/* Close */}
        <button
          onClick={handleClose}
          title="Close Editor"
          className="
            p-2 rounded-md
            bg-gray-200 hover:bg-gray-300
            dark:bg-gray-800 dark:hover:bg-gray-700
            transition-colors
          "
        >
          <X size={18} />
        </button>


      </div>
    </header>
  );
}
